import React, { useState } from 'react'
import { withRouter } from 'react-router';
import { TextField, Grid, Button, Dialog, DialogActions, DialogContent, DialogTitle, Table, TableHead, TableBody, TableCell, CircularProgress, TableRow } from '@material-ui/core';
import { read, utils } from 'xlsx';
import { GetApp } from '@material-ui/icons';
import { checkApiStatus, downloadFileType } from '../../../utils_v2';
import { globalPostService, globalExportService } from '../../../utils_v2/globalApiServices';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import { trackActivity } from '../../../utils/mixpanel';
import { DropzoneArea } from 'material-ui-dropzone'
import { useSnackbar } from 'notistack';

export default function ImportQuestion({ params, toggleModalFn, type, importCheckList, importQuestions }) {
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [isLoading, setLoading] = useState(false);
    const [questionsData, setQuestionsData] = useState([]);
    const onFieldChangeQuestion = (e, keyParam, value, index) => {
        setQuestionsData(questionsData.map((item, itemIndex) => itemIndex !== index ? item : { ...item, [keyParam]: value }))
    }
    const onRemoveQuestion = (index) => {
        setQuestionsData(questionsData.filter((item, itemIndex) => index !== itemIndex))
    }
    const onFilesDrop = (files) => {
        if (files && files.length > 0) {
            setLoading(true);
            const file = files[0];
            if (file instanceof Blob) {
                const reader = new FileReader();
                reader.onload = function (e) {
                    const buffer = e.target.result;
                    const wb = read(new Uint8Array(buffer));
                    const ws = wb.Sheets[wb.SheetNames[0]];
                    const data = utils.sheet_to_json(ws, { blankRows: false });
                    setLoading(false);
                    if (data.length === 0) {
                        enqueueSnackbar("Invalid Data", { variant: 'error', anchorOrigin: { horizontal: 'right', vertical: 'top' } })
                    }
                    setQuestionsData(data);
                };
                reader.readAsArrayBuffer(file);
            } else {
                console.error("Invalid file object. Expected a Blob.");
            }
        }

    }
    const onImportQuestions = () => {
        // Validations for Template Import;
        setLoading(true);
        // technical/v2/workorder/cLmsGj/workbook/sections/9600/questions/import/?asset_type=aircraft&timestamp=1769682683528' \
        globalPostService(`technical/v2/workorder/${params.workOrderSlug}/workbook/sections/${importQuestions?.sectionId}/questions/import/?asset_type=${params?.type}`, questionsData)
            .then(response => {
                setLoading(false);
                if (checkApiStatus(response)) {
                    enqueueSnackbar(response.data.message, { variant: 'success', anchorOrigin: { horizontal: 'right', vertical: 'top' } })
                    window.location.reload();
                    toggleModalFn();
                    trackActivity('Project Management', { event_type: 'Question Import Success', page_title: 'T003 Form', workOrder_slug: params.workOrderSlug ? params.workOrderSlug : '', request_body: questionsData ? questionsData : '', response: response.data.data, success_msg: response.data.message });
                } else {
                    enqueueSnackbar(response.data.message, { variant: 'error', anchorOrigin: { horizontal: 'right', vertical: 'top' } })
                    trackActivity('Project Management', { event_type: 'Question Import Failed', page_title: 'T003 Form', workOrder_slug: params.workOrderSlug ? params.workOrderSlug : '', request_body: questionsData ? questionsData : '', error_msg: response.data.data, error_source: 'Backend' });
                }
            })
    }
        const downloadSampleTemplate = () => {
            globalExportService(`technical/v2/workorder/${params.workOrderSlug}/workbook/sections/${importQuestions?.sectionId}/questions/sample-questions-download/?asset_type=${params?.type}`)
                .then(response => {
                    downloadFileType(response, 'T003_Question_Template.', 'xls')
                    trackActivity('Project Management', {
                        event_type: 'Sample Question Template Downloaded',
                        page_title: 'T003 Form',
                        workOrder_slug: params.workOrderSlug ? params.workOrderSlug : '',
                        file_name: 'T003_Sample_Template',
                        file_extension: 'xls'
                    });
                })
        }
    return (
        <Dialog
            open={true}
            onClose={toggleModalFn}
            className='project-management-modal'
            maxWidth='lg'
        >
            <DialogTitle> Import Questions  </DialogTitle>
            <DialogContent dividers={true} >
                <div style={{ width: "828px", height: "378px" }}>
                    <Grid container spacing={1}>
                        <Grid item sm='12'>
                            <DropzoneArea
                                acceptedFiles={['.xls, .xlsx']}
                                filesLimit={1}
                                maxFileSize={10428800}
                                showPreviewsInDropzone={false}
                                useChipsForPreview={false}
                                showPreviews={false}
                                dropzoneText={<p style={{ fontSize: '13px' }}>Drag & Drop Documents<br /> OR <br /> Click Here<br /> </p>}
                                dropzoneClass="drag-drop-cnt"
                                maxWidth="sm"
                                showAlerts={['info', 'error']}
                                alertSnackbarProps={{ anchorOrigin: { vertical: 'top', horizontal: 'right' } }}
                                clearOnUnmount={true}
                                onChange={(files) => onFilesDrop(files)}
                            />
                            <div>
                                {questionsData.length ?
                                    <Table className='mui-table-format'>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>Question(s)</TableCell>
                                                <TableCell>Answer(s)</TableCell>
                                                <TableCell>Note(s)</TableCell>
                                                <TableCell>Action</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {questionsData.map((questionsData, index) => (
                                                <TableRow>
                                                    <TableCell>
                                                        <TextField
                                                            id={`${index}`}
                                                            fullWidth
                                                            margin="none"
                                                            value={questionsData['Question'] || ''}
                                                            InputLabelProps={{ shrink: true }}
                                                            variant='outlined'
                                                            onChange={(e) => onFieldChangeQuestion(e, 'Question', e.target.value, index)}
                                                        />
                                                    </TableCell>
                                                    <TableCell>
                                                        <TextField
                                                            id={`${index}`}
                                                            fullWidth
                                                            margin="none"
                                                            value={questionsData['Answer'] || ''}
                                                            InputLabelProps={{ shrink: true }}
                                                            onChange={(e) => onFieldChangeQuestion(e, 'Answer', e.target.value, index)}
                                                            variant='outlined'
                                                        />
                                                    </TableCell>
                                                    <TableCell>
                                                        <TextField
                                                            id={`notes${index}`}
                                                            fullWidth
                                                            margin="none"
                                                            value={questionsData['Notes'] || ''}
                                                            InputLabelProps={{ shrink: true }}
                                                            onChange={(e) => onFieldChangeQuestion(e, 'Notes', e.target.value, index)}
                                                            variant='outlined'
                                                        />
                                                    </TableCell>
                                                    <TableCell>
                                                        {questionsData.length !== 1 ?
                                                            <DeleteOutlineIcon color='secondary' onClick={() => onRemoveQuestion(index)} /> : null
                                                        }
                                                    </TableCell>
                                                </TableRow>))}
                                        </TableBody>
                                    </Table> : null
                                }
                            </div>
                        </Grid>
                        <div>
                            <p style={{ fontSize: '13px', fontStyle: 'italic', color: '#717171' }}>Note: Please download "Sample Question template", edit the template in Excel and upload the same for further customization. </p>
                            <p className='download-sample-temp' onClick={() => downloadSampleTemplate()} > <GetApp /> Download Sample Question template</p>
                        </div>
                    </Grid>
                </div>
            </DialogContent>
            <DialogActions>
                <Button disabled={isLoading} onClick={toggleModalFn} color="primary" size='small' variant='outlined'>Cancel</Button>
                {questionsData.length ?
                    <Button disabled={isLoading} onClick={onImportQuestions} color="primary" size='small' variant='contained'>
                        {isLoading ? <CircularProgress size={20} /> : 'Save'}
                    </Button> : null
                }
            </DialogActions>
        </Dialog>
    )
}
